import { createContext } from 'react';

import type { InteractionMode } from '../../interactions-overlay/types.js';

export interface ChartToolbarContextProps {
  updateLastItemSelected: (state: InteractionMode | undefined) => void;
  /** Indicates that controls are inside a dropdown menu. */
  isMenuElement?: boolean;
  /** Indicates that the toolbar is currently expanded. */
  isExpanded?: boolean;
  lastItemSelected?: InteractionMode;
}

export const ChartToolbarContext = createContext<ChartToolbarContextProps>({
  isMenuElement: false,
  isExpanded: true,
  lastItemSelected: undefined,
  updateLastItemSelected: (state: InteractionMode | undefined) => {
    return;
  },
});

ChartToolbarContext['displayName'] = 'ToolbarContext';
